export default __webpack_public_path__ + "static/media/doc-icon.47d6a52c.svg";